import React from "react";

import Hero from "./sections/Hero";
import Tabs from "./sections/Tabs";
import Stats from "./sections/Stats";

const ServiceRegister = () => {
  return (
    <>
      <Hero />
      <Tabs />
      <Stats/>
    </>
  )
}

export default ServiceRegister;
